export default __webpack_public_path__ + "static/media/custom-branding-image.a2bea802.jpeg";